import React, { useState, useRef, useEffect } from 'react';
import { useNavigate, useLocation } from "react-router-dom";
import { MdAccountCircle, MdWorkHistory } from "react-icons/md";
import { AiOutlineHome, AiFillHome } from "react-icons/ai";
import { RiAccountCircleLine } from "react-icons/ri";
import { signInWithGoogle, googleLogout, checkUserAuth } from '../firebase';
import { RiSlideshowLine, RiSlideshowFill } from "react-icons/ri";
import { BsPersonWorkspace } from "react-icons/bs";
import { IoAddCircle, IoAddCircleOutline } from "react-icons/io5";
import { BsPlayBtn, BsPlayBtnFill } from "react-icons/bs";
import Photosicon from '../assets/photos_icon.png';
import Cookies from 'js-cookie';
import "../master_root/Navbar.css";

export default function Navbarwoarkstation() {
    const location = useLocation(); // Get current route
    const navigate = useNavigate();
    const [user, setUser] = useState(null);
    const [guid, setGuid] = useState("");
    const [photoURL, setPhotoURL] = useState("");
    const [userlogin, setuserlogin] = useState(false);
    useEffect(() => {
        const existingUser = Cookies.get("guid");
        if (existingUser != null) {
            setGuid(existingUser);
            setuserlogin(true);
            const photo = Cookies.get("login_photoURL");

            setPhotoURL(photo);
        } else {
            setuserlogin(false);
        }
    }, []);


    return (
        <nav className="navbar">
            <div
                onClick={() => navigate('/ws')}
                className={`menubutton-icon ${location.pathname === '/ws' ? 'active' : ''}`}
                title="Home"
            >
                {location.pathname === '/ws' ? (
                    <AiFillHome className="icon" />
                ) : (
                    <AiOutlineHome className="icon" />
                )}

                <span className="button-text">Home</span>
            </div>
            <div
                onClick={() => navigate('/upcoming-task')}
                className={`menubutton-icon ${location.pathname === '/upcoming-task' ? 'active' : ''}`}
                title="Upcoming task"
            >

                {location.pathname === '/upcoming-task' ? (
                    <RiSlideshowFill className="icon" />
                ) : (
                    <RiSlideshowLine className="icon" />
                )}
                <span className="button-text">Upcoming task</span>
            </div>
            <div
                onClick={() => navigate('/work-history')}
                className={`menubutton-icon ${location.pathname === '/work-history' ? 'active' : ''}`}
                title="Work history"
            >

                {location.pathname === '/work-history' ? (
                    <BsPersonWorkspace className="icon" />
                ) : (
                    <BsPersonWorkspace className="icon" />
                )}
                <span className="button-text">Work history</span>
            </div>



            {userlogin == true && (
                <div
                    className={`menubutton-icon ${location.pathname === '/account' ? 'active' : ''}`}
                    title="Account"
                >
                    <img onClick={() => navigate('/account')}
                        className="img-icon"
                        src={photoURL}
                        alt="User"
                        onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = Photosicon;
                        }}
                    />
                </div>
            )}
            {userlogin == false && (
                <div onClick={() => navigate('/login')}
                    className={`menubutton-icon ${location.pathname === '/login' ? 'active' : ''}`}
                    title="login"
                >
                    <RiAccountCircleLine alt="Login" className="img-icon" />
                    <span className="button-text">Login</span>
                </div>
            )}

        </nav>
    );
};